import React from "react";
import { ButtonTemplate } from "../Templates/buttonTemplates";
import { ButtonParts } from "../Parts/buttonParts";
import { FlowParts } from "../Parts/flowParts";

export const OtherProductsView = (props) => {

    return  (
        <>
         
         <div className="select">
         <FlowParts {...{flow:'flow1'}}></FlowParts>
         <div className="select_contents">
            <div className="select_desc">期間中に福岡県のLPガス販売店で購入した商品が他にありますか？</div>

            <div className="mb-20"><img src={`${process.env.REACT_APP_HOME_URL}/images/gaskigu.jpg`} alt="ガス器具"/></div>
            <div className="mb-40">※対象店舗は店舗選択画面で確認できます</div>
            <ButtonTemplate>
                <ButtonParts {...{type:'yes', 
                    onClickEvent:()=>{
                        props.ohterProductYes()
                    }}}></ButtonParts>

                <ButtonParts {...{type:'no', 
                        onClickEvent:()=>{
                            props.ohterProductNo()
                        }}}></ButtonParts>
            </ButtonTemplate>
        </div>
        </div>
        </>
    )
}